import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { isNil, toString, omit } from 'lodash';

import Icon from 'components/Icon/';
import styled, { css } from 'styled-components';

// Wrap your select element in <SelectWrap> for custom styled select boxes
// NOTE: Provide an onChange, value and defaultValue to <SelectWrap> instead of <select>

const StyledIcon = styled.span`
  position: absolute;
  top: 0px;
  right: 8px;
  display: flex;
  align-items: center;
  height: 100%;
`;

const StyledText = styled.span`
  display: inline-block;
  width: 100%;
  overflow: hidden;
  vertical-align: top;
  word-break: break-all;
  max-height: 1.25rem;
  padding-right: 20px;
  line-height: 24px;
`;

const StyledSelectWrapContainer = styled.div(
  ({ theme }) => css`
    position: relative;
    overflow: hidden;
    line-height: 1.25rem;
    border: 1px solid ${theme.colors.alto};
    padding: 0.5rem 0.75rem;
    background-color: ${theme.colors.white};

    &.disabled {
      background: #eceeef;
    }
    & > select {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      cursor: pointer;
    }
  `
);

export default class SelectWrap extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      display: '',
    };
  }

  componentDidMount() {
    this.setInitialDisplay();
  }

  componentDidUpdate(prevProps) {
    const hasValueChanged =
      !isNil(this.props.value) && toString(prevProps.value) !== toString(this.props.value);

    if (hasValueChanged) {
      this.setInitialDisplay();
    }
  }

  setInitialDisplay() {
    if (!this._select) return;

    const index = this._select.selectedIndex;
    this.setState({
      display: this._select[index].text,
    });
  }

  handleChange = (event) => {
    const index = event.nativeEvent.target.selectedIndex;
    const { text } = event.nativeEvent.target[index];

    this.setState({
      display: text,
    });

    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };

  render() {
    const { className, disabled, children, ...selectProps } = this.props;
    const select = React.cloneElement(children, {
      onChange: this.handleChange,
      ref: (ref) => {
        this._select = ref;
      },
      disabled,
      ...omit(selectProps, 'onChange'),
    });

    const classNames = cx(['select-wrap', 'form-control', className], { disabled });

    return (
      <StyledSelectWrapContainer className={classNames}>
        <StyledIcon>
          <Icon name="arrowDown" size={24} fill="#404040" />
        </StyledIcon>
        <StyledText>{this.state.display}</StyledText>
        {select}
      </StyledSelectWrapContainer>
    );
  }
}
